import Service from "./Service"

class ToolService extends Service {

    findById = (id) => this.get(`/tools/${id}`)

    search = (queryParams) => this.getWithParams("/tools", queryParams)

    deleteTool = (id) => this.del(`/tools/${id}`)
}

const toolService = new ToolService()
export default toolService